module.exports = __webpack_public_path__ + "img/delete.a30174e0.svg";